import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; import React from 'react';
import Calculator from './components/Calculator';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Quote from './components/Quote';

const App = () => (
  <Router>
    <div className="App">
      <Navbar />
      <div className="components">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/quote" element={<Quote />} />
        </Routes>
      </div>
    </div>
  </Router>

);

export default App;
